/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Api
 * ApiのマージされたAPI仕様書
 * OpenAPI spec version: api
 */
import useSwr from 'swr'
import type { Key, SWRConfiguration } from 'swr'

import type {
  GetV3EventsEventIdInventories200,
  GetV3EventsEventIdInventoriesParams,
  GetV3HomeInventoriesParams,
  GetV3Inventories200,
  GetV3Inventories404,
  GetV3InventoriesId200,
  GetV3InventoriesId403,
  GetV3InventoriesId404,
  GetV3InventoriesParams,
  InventoryListItem,
} from '../models'

import { customInstance } from '../../libs/orval/customInstance'
import type { ErrorType } from '../../libs/orval/customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary index
 */
export const getV3HomeInventories = (
  params?: GetV3HomeInventoriesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<InventoryListItem[]>(
    { url: `/v3/home/inventories`, method: 'GET', params },
    options,
  )
}

export const getGetV3HomeInventoriesKey = (
  params?: GetV3HomeInventoriesParams,
) => [`/v3/home/inventories`, ...(params ? [params] : [])] as const

export type GetV3HomeInventoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV3HomeInventories>>
>
export type GetV3HomeInventoriesQueryError = ErrorType<unknown>

/**
 * @summary index
 */
export const useGetV3HomeInventories = <TError = ErrorType<unknown>>(
  params?: GetV3HomeInventoriesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getV3HomeInventories>>,
      TError
    > & { swrKey?: Key; enabled?: boolean }
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetV3HomeInventoriesKey(params) : null))
  const swrFn = () => getV3HomeInventories(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  )

  return {
    swrKey,
    ...query,
  }
}
/**
 * @summary index
 */
export const getV3Inventories = (
  params?: GetV3InventoriesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetV3Inventories200>(
    { url: `/v3/inventories`, method: 'GET', params },
    options,
  )
}

export const getGetV3InventoriesKey = (params?: GetV3InventoriesParams) =>
  [`/v3/inventories`, ...(params ? [params] : [])] as const

export type GetV3InventoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV3Inventories>>
>
export type GetV3InventoriesQueryError = ErrorType<GetV3Inventories404>

/**
 * @summary index
 */
export const useGetV3Inventories = <TError = ErrorType<GetV3Inventories404>>(
  params?: GetV3InventoriesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getV3Inventories>>,
      TError
    > & { swrKey?: Key; enabled?: boolean }
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetV3InventoriesKey(params) : null))
  const swrFn = () => getV3Inventories(params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  )

  return {
    swrKey,
    ...query,
  }
}
/**
 * @summary show
 */
export const getV3InventoriesId = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetV3InventoriesId200>(
    { url: `/v3/inventories/${id}`, method: 'GET' },
    options,
  )
}

export const getGetV3InventoriesIdKey = (id: string) =>
  [`/v3/inventories/${id}`] as const

export type GetV3InventoriesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV3InventoriesId>>
>
export type GetV3InventoriesIdQueryError = ErrorType<
  GetV3InventoriesId403 | GetV3InventoriesId404
>

/**
 * @summary show
 */
export const useGetV3InventoriesId = <
  TError = ErrorType<GetV3InventoriesId403 | GetV3InventoriesId404>,
>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getV3InventoriesId>>,
      TError
    > & { swrKey?: Key; enabled?: boolean }
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!id
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetV3InventoriesIdKey(id) : null))
  const swrFn = () => getV3InventoriesId(id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  )

  return {
    swrKey,
    ...query,
  }
}
/**
 * @summary index
 */
export const getV3EventsEventIdInventories = (
  eventId: string,
  params?: GetV3EventsEventIdInventoriesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetV3EventsEventIdInventories200>(
    { url: `/v3/events/${eventId}/inventories`, method: 'GET', params },
    options,
  )
}

export const getGetV3EventsEventIdInventoriesKey = (
  eventId: string,
  params?: GetV3EventsEventIdInventoriesParams,
) => [`/v3/events/${eventId}/inventories`, ...(params ? [params] : [])] as const

export type GetV3EventsEventIdInventoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV3EventsEventIdInventories>>
>
export type GetV3EventsEventIdInventoriesQueryError = ErrorType<unknown>

/**
 * @summary index
 */
export const useGetV3EventsEventIdInventories = <TError = ErrorType<unknown>>(
  eventId: string,
  params?: GetV3EventsEventIdInventoriesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getV3EventsEventIdInventories>>,
      TError
    > & { swrKey?: Key; enabled?: boolean }
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!eventId
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetV3EventsEventIdInventoriesKey(eventId, params) : null)
  const swrFn = () =>
    getV3EventsEventIdInventories(eventId, params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  )

  return {
    swrKey,
    ...query,
  }
}
